import React from "react";
import LayerGroup from "../../../../types/LayerGroup";
import LayerLegend from "../sharedComponents/LayerLegend";
import LegendRow from "../sharedComponents/LegendRow";

class NaturalAndMarineProtectedLandsLegend extends React.PureComponent<{}, {}> {
  render() {
    return (
      <LayerLegend
        layerGroup={LayerGroup.NaturalAndMarineProtectedLands}
        classes="protected-areas"
        legendRows={[
          <LegendRow
            color="#b2df8a"
            text="Protected Areas"
          />
        ]}
      />
    );
  }
}

export default NaturalAndMarineProtectedLandsLegend;
